import React from 'react'

import _ from 'lodash'
import * as firebase from 'firebase'
import { connect } from 'react-redux'

import Popover from 'material-ui/Popover'
import Divider from 'material-ui/Divider'
import Checkbox from 'material-ui/Checkbox'
import GroupIcon from 'material-ui/svg-icons/social/group'

import ModulesUtils from '../../../../infra/ModulesUtils'

class Assignees extends React.Component {

  constructor(props) {
    super(props);

    if (!props.assignees.list) {
      props.assignees.list = {};
    }

    this.state = {
      workers: props.workers,
      assignees: props.assignees,
      openPopover: false
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      workers: nextProps.workers,
      assignees: nextProps.assignees
    })
  }

  onCheck(workerId, isChecked) {
    // Open to everyone flag
    if (workerId === -1) {
      firebase.database().ref(this.props.dbPath + '/assignees')
        .set({ open: isChecked })
      return
    }
    // A particular worker selected/deselected
    const updates = {}

    if (this.state.assignees.open) {
      // Handle the case that the task is open and someone gets deselected.
      // In this case, make the open field false and check the other workers
      const workersList = this.state.workers.list
      for (const wId in workersList) {
        updates[this.props.dbPath + '/assignees/list/' + wId] =
          wId === workerId ? null : { id: workerId, selected: true }
      }
    }
    else {
      updates[this.props.dbPath + '/assignees/list/' + workerId] =
        !isChecked ? null : { id: workerId, selected: isChecked }
    }

    if (this.isEveryoneAssigned(workerId, isChecked)){
      updates[this.props.dbPath + '/assignees/open'] = true
    } else {
      updates[this.props.dbPath + '/assignees/open'] = false
    }

    firebase.database().ref().update(updates);
  }

  isEveryoneAssigned(workerId, isChecked){
    const newAssignees = { ...this.state.assignees.list }
    const workers = { ...this.state.workers.list }

    if (isChecked){
      newAssignees[workerId] = true
    } else {
      delete newAssignees[workerId]
    }
    return _.keys(newAssignees).length === _.keys(workers).length
  }

  renderItem(workerId) {
    let selected = this.state.assignees.open
    if (workerId !== -1 && !selected) {
      selected = (this.state.assignees.list !== undefined)
        && this.state.assignees.list.hasOwnProperty(workerId)
        && this.state.assignees.list[workerId].selected;
    }

    const text = workerId === -1
      ? 'Any Worker' : ModulesUtils.getMemberName(this.props.teamMembers, workerId);
    let checkColor = '#8c8c8c';
    if ((this.state.assignees.open && workerId === -1)
      || (!this.state.assignees.open && workerId !== -1)) {
      checkColor = '#527da3'
    }

    return (
      <div
        key={workerId}
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

        <Checkbox
          style={{ width: '24px', alignItems: 'center' }}
          iconStyle={{ fill: checkColor }}
          checked={selected}
          onCheck={(event, isChecked) => this.onCheck(workerId, isChecked)}/>

        <span
          style={{ fontSize: 16 }}>
          {text}
        </span>
      </div>
    );
  }

  renderWorkers() {
    const views = []
    // Everybody flag
    views.push(this.renderItem(-1))
    views.push(
      <Divider
        style={{ marginTop: 4, marginBottom: 4 }}
        key='divider'/>);

    if (this.state.workers && this.state.workers.list) {
      for (const key in this.state.workers.list) {
        if (!this.state.workers.list.hasOwnProperty(key)) {
          continue;
        }

        const worker = this.state.workers.list[key];
        views.push(this.renderItem(worker.id));
      }
    }

    return views;
  }

  handleGroupClicked = (event) => {
    event.preventDefault()
    this.anchorElement = event.currentTarget
    this.setState({
      openPopover: true,
      anchorElement: event.currentTarget
    })
  }

  render() {
    let countOfAssignees = 0;
    if (this.state.assignees.open) {
      countOfAssignees = '*';
    } else {
      const list = this.state.assignees.list;
      for (const key in list) {
        if (!list.hasOwnProperty(key)) {
          continue;
        }

        if (list[key].selected) {
          countOfAssignees++;
        }
      }
    }
    return (
      <div onClick={this.handleGroupClicked}>
        <span
          style={{ marginLeft: 8, marginRight: 4,
            color: 'rgba(0,0,0,0.55)', fontSize: 14 }}>
          {countOfAssignees}
        </span>

        <GroupIcon
          style={{ color: 'rgba(0,0,0,0.4)' }}/>

        <Popover
          open={this.state.openPopover}
          anchorEl={this.anchorElement}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={() => this.setState({ openPopover: false })}>
          {this.renderWorkers()}
        </Popover>
      </div>
    );
  }
}

export default connect(state => ({ teamMembers: state.firebase.team.members.value }))(Assignees)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/common/Assignees.js